const tours = [
  {
    id: 'certified',
    badge: 'Best Seller',
    badgeColor: 'bg-orange-500',
    borderColor: 'border-orange-200 hover:border-orange-300',
    img: 'https://public.readdy.ai/ai/img_res/9bf524176007ea226bfc0005a932d605.jpg',
    imgAlt: 'Certified Dive Tour',
    tagColor: 'text-cyan-500',
    tag: 'For Certified Divers',
    icon: 'ri-bubble-chart-line',
    title: 'Certified Dive Tour',
    desc: 'Dive Beaver Reef and the outer Great Barrier Reef aboard MV Mahi-Mahi with PADI-certified dive guides who know every coral head and current. Suitable for Open Water certified divers and above.',
    includes: [
      '2 reef site dives',
      'All dive equipment & wetsuit',
      'PADI dive guide',
      'Reef tax / Marine Park fee',
      'Lunch & refreshments',
      'Water taxi transfer',
    ],
    price: '$799',
    priceNote: 'per person · 2 reef sites',
    pill: 'Open Water certified & above',
    pillColor: 'text-emerald-600 bg-emerald-50',
    priceColor: 'text-gray-900',
    ctaColor: 'from-cyan-500 to-teal-500',
    ctaLabel: 'Book Certified Diver Trip',
  },
  {
    id: 'discover',
    badge: 'Most Popular',
    badgeColor: 'bg-gradient-to-r from-orange-500 to-amber-500',
    borderColor: 'border-orange-200 ring-2 ring-orange-400 ring-offset-2',
    img: 'https://public.readdy.ai/ai/img_res/fa8a91f943cc1f736c8bcb1f70439034.jpg',
    imgAlt: 'Discover Scuba Diving',
    tagColor: 'text-orange-500',
    tag: 'No Experience Needed',
    icon: 'ri-water-flash-line',
    title: 'Discover Scuba Diving',
    desc: 'Never dived before? Our PADI Discover Scuba Diving program gets you underwater safely with zero prior experience required. A PADI instructor is with you every fin-kick of the way.',
    includes: [
      'All dive equipment & wetsuit',
      'PADI instructor (1-on-1)',
      'Reef tax / Marine Park fee',
      'Lunch & refreshments',
      'Water taxi transfer',
    ],
    price: '$699',
    priceNote: 'per person · no cert needed',
    pill: 'No experience required',
    pillColor: 'text-emerald-600 bg-emerald-50',
    priceColor: 'text-gray-900',
    ctaColor: 'from-orange-500 to-amber-500',
    ctaLabel: 'Book Discover Scuba',
  },
  {
    id: 'snorkel',
    badge: null,
    badgeColor: '',
    borderColor: 'border-gray-100 hover:border-cyan-200',
    img: 'https://readdy.ai/api/search-image?query=snorkeler%20floating%20above%20vibrant%20Great%20Barrier%20Reef%20coral%20gardens%20Queensland%20Australia%2C%20aerial%20underwater%20view%2C%20tropical%20fish%20and%20sea%20turtles%20visible%20below%20surface%2C%20crystal%20clear%20turquoise%20water%2C%20bright%20sunny%20tropical%20day%2C%20stunning%20reef%20colors%2C%20shallow%20reef%20snorkeling%20experience&width=400&height=280&seq=bedarra-exp-03&orientation=landscape',
    imgAlt: 'All Day Snorkel Tour',
    tagColor: 'text-cyan-500',
    tag: 'For Everyone',
    icon: 'ri-sun-line',
    title: 'All Day Snorkel Tour',
    desc: 'Join us aboard MV Mahi-Mahi for a guided snorkel experience floating above the coral gardens of the Great Barrier Reef. Turtles, reef sharks, giant clams — the outer reef delivers.',
    includes: [
      'Full day on the reef',
      'Snorkel gear (mask, fins, wetsuit)',
      'Guided snorkel session',
      'Reef tax / Marine Park fee',
      'Lunch & refreshments',
      'Water taxi transfer',
      'Underwater photos',
    ],
    price: '$449',
    priceNote: 'per person · full day',
    pill: 'Suitable for all ages',
    pillColor: 'text-emerald-600 bg-emerald-50',
    priceColor: 'text-gray-900',
    ctaColor: 'from-emerald-500 to-teal-400',
    ctaLabel: 'Book Snorkel Trip',
  },
];

const pricingCards = [
  {
    label: 'Certified Divers',
    icon: 'ri-bubble-chart-line',
    iconBg: 'bg-cyan-50 text-cyan-600',
    title: 'Certified Diver Day Trip',
    price: '$799',
    priceColor: 'text-cyan-600',
    border: 'border-2 border-cyan-200',
    includes: [
      'Water taxi transfer from Bedarra Island',
      'Return boat trip aboard MV Mahi-Mahi',
      '2 guided dives on the outer reef',
      'All scuba equipment & tanks',
      'PADI-certified dive guide',
      'Reef entry fees & GST',
    ],
    checkColor: 'text-cyan-600',
    ctaColor: 'from-cyan-500 to-teal-500',
    ctaLabel: 'Book Certified Diver Trip',
    popular: false,
  },
  {
    label: 'First-Timers',
    icon: 'ri-water-flash-line',
    iconBg: 'bg-orange-50 text-orange-600',
    title: 'Discover Scuba Diving',
    price: '$699',
    priceColor: 'text-orange-600',
    border: 'border-2 border-orange-200 ring-2 ring-orange-400 ring-offset-2',
    includes: [
      'Water taxi transfer from Bedarra Island',
      'Return boat trip aboard MV Mahi-Mahi',
      'PADI Discover Scuba Diving program',
      '1-on-1 PADI instructor in the water',
      'All equipment provided',
      'Reef entry fees & GST',
    ],
    checkColor: 'text-orange-600',
    ctaColor: 'from-orange-500 to-amber-500',
    ctaLabel: 'Book Discover Scuba',
    popular: true,
  },
  {
    label: 'Non-Divers',
    icon: 'ri-sun-line',
    iconBg: 'bg-emerald-50 text-emerald-600',
    title: 'Snorkel Day Trip',
    price: '$459',
    priceColor: 'text-emerald-600',
    border: 'border-2 border-emerald-200',
    includes: [
      'Water taxi transfer from Bedarra Island',
      'Return boat trip aboard MV Mahi-Mahi',
      'Guided snorkel session on the reef',
      'Mask, fins & snorkel provided',
      'Reef entry fees & GST',
    ],
    checkColor: 'text-emerald-600',
    ctaColor: 'from-emerald-500 to-teal-400',
    ctaLabel: 'Book Snorkel Trip',
    popular: false,
  },
];

export default function ToursSection() {
  return (
    <section id="tours" className="w-full py-24 px-6 md:px-10" style={{ background: 'rgb(248,250,252)' }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[3px] text-cyan-500 font-semibold mb-4">What's On Offer</p>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-5">Your Reef. Your Day.</h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed font-light">
            Great Barrier Reef diving from Mission Beach suits every level — seasoned diver, total first-timer, or just want to float above the coral. There's a place on MV Mahi-Mahi for all of you.
          </p>
        </div>

        {/* Tour Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start mb-20">
          {tours.map((tour) => (
            <div key={tour.id} className={`group flex flex-col rounded-2xl overflow-hidden border transition-all duration-300 hover:-translate-y-1 ${tour.borderColor} bg-white`}>
              {tour.badge && (
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    alt={tour.imgAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    width={400}
                    height={280}
                    loading="lazy"
                    src={tour.img}
                  />
                  <div className={`absolute top-3 left-3 flex items-center gap-1.5 ${tour.badgeColor} text-white text-xs font-bold px-3 py-1.5 rounded-full`}>
                    <i className="ri-award-fill text-sm"></i>{tour.badge}
                  </div>
                </div>
              )}
              {!tour.badge && (
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    alt={tour.imgAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    width={400}
                    height={280}
                    loading="lazy"
                    src={tour.img}
                  />
                </div>
              )}
              <div className="flex flex-col flex-1 p-7 bg-white">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cyan-50 text-cyan-500">
                    <i className={`${tour.icon} text-xl`}></i>
                  </div>
                  <span className={`text-xs font-semibold uppercase tracking-widest ${tour.tagColor}`}>{tour.tag}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-snug">{tour.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{tour.desc}</p>
                <div className="mt-5 pt-5 border-t border-gray-100">
                  <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-3">What's Included</p>
                  <ul className="space-y-2">
                    {tour.includes.map((item) => (
                      <li key={item} className="flex items-center gap-2.5 text-sm text-gray-600">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 text-emerald-500">
                          <i className="ri-check-line text-base"></i>
                        </div>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-5 pt-5 border-t border-gray-100 flex items-baseline gap-2">
                  <span className="text-3xl font-black text-gray-900">{tour.price}</span>
                  <span className="text-xs text-gray-400 font-medium">{tour.priceNote}</span>
                </div>
                <div className={`mt-4 inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full w-fit ${tour.pillColor}`}>
                  <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center"></i>
                  {tour.pill}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 text-center mb-20">
          <p className="text-gray-400 text-sm mb-5 tracking-wide">All experiences depart from Clump Point Jetty, Mission Beach — a short transfer from Bedarra Island.</p>
          <a
            href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-sm cursor-pointer hover:scale-105 transition-transform duration-300"
          >
            <i className="ri-calendar-check-line w-5 h-5 flex items-center justify-center"></i>
            Book Your Dive Day Trip
          </a>
        </div>

        {/* Pricing */}
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[3px] text-cyan-500 font-semibold mb-4">Pricing</p>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 leading-tight">All-Inclusive Package Prices</h2>
          <p className="text-gray-400 text-sm mt-3">Transfer, boat, gear, guide & reef fees — everything included. No surprises.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {pricingCards.map((card) => (
            <div key={card.label} className={`relative flex flex-col rounded-2xl overflow-hidden bg-white ${card.border}`}>
              {card.popular && (
                <div className="absolute top-0 left-0 right-0 text-center py-1.5 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-[10px] font-bold uppercase tracking-widest">
                  Most Popular
                </div>
              )}
              <div className={`p-7 ${card.popular ? 'pt-10' : ''}`}>
                <div className="flex items-center gap-3 mb-5">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full ${card.iconBg}`}>
                    <i className={`${card.icon} text-xl`}></i>
                  </div>
                  <span className={`text-xs font-semibold uppercase tracking-widest ${card.priceColor}`}>{card.label}</span>
                </div>
                <h3 className="text-lg font-black text-gray-900 mb-1 leading-snug">{card.title}</h3>
                <div className="flex items-baseline gap-1 mb-6">
                  <span className={`text-4xl font-black ${card.priceColor}`}>{card.price}</span>
                  <span className="text-gray-400 text-sm font-light">AUD / person</span>
                </div>
                <ul className="flex flex-col gap-2.5 mb-8">
                  {card.includes.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-sm text-gray-600">
                      <div className={`w-4 h-4 flex items-center justify-center shrink-0 mt-0.5 ${card.checkColor}`}>
                        <i className="ri-check-line text-sm"></i>
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>
                <a
                  href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`whitespace-nowrap w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full font-bold text-sm cursor-pointer hover:scale-105 transition-transform duration-300 text-white bg-gradient-to-r ${card.ctaColor}`}
                >
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                  {card.ctaLabel}
                </a>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-xs mt-8 leading-relaxed">
          All prices in AUD and include GST, reef entry fees, and Bedarra Island water taxi transfer. Prices subject to change — contact us to confirm availability and current rates.
        </p>
      </div>
    </section>
  );
}
